// Angular imports
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

// 3rd party imports
import {
  DxValidationGroupComponent,
  DxPopupComponent
} from 'devextreme-angular';

// CC-Common imports
import { IconConstants } from '@therealmanage/ciranet-ui-common';
import { RxjsUtils } from '@therealmanage/ciranet-ui-common';

// Service imports
import { UserService } from '../../_services/data-services/user.service';
import { ServerErrorService } from '../../_services/shared-services/server-error.service';

// Model imports
import { ImpersonateParameterDto } from '../../_models/impersonate-parameter-dto';
import { ImpersonateResultDto } from '../../_models/impersonate-result-dto';

@Component({
  selector: 'app-impersonate',
  templateUrl: './impersonate.component.html',
  styleUrls: ['./impersonate.component.scss'],
  standalone: false
})
export class ImpersonateComponent implements OnInit {
  @ViewChild('validatorImpersonate', { static: false })
  validatorImpersonate: DxValidationGroupComponent;
  @ViewChild('impersonatePopup', { static: false })
  impersonatePopup: DxPopupComponent;

  loadingVisible: boolean = false;
  impersonateVisible: boolean = false;
  impersonateParameter: ImpersonateParameterDto = new ImpersonateParameterDto();
  impersonateHistory: ImpersonateParameterDto[];
  isImpersonateDisabled: boolean = true;

  cancelIcon = IconConstants.CANCEL;
  saveIcon = IconConstants.SAVE;

  constructor(
    private userService: UserService,
    private router: Router,
    private errorService: ServerErrorService
  ) {}

  ngOnInit() {
    this.impersonateHistory = this.userService.getImpersonateHistory();
    RxjsUtils.safeSubscribe(
      this.userService.getSubjectImpersonateHistory(),
      (data: ImpersonateParameterDto[]) => {
        this.impersonateHistory = data;
      }
    );
  }

  show(): void {
    this.impersonateVisible = true;
  }

  hide(): void {
    this.impersonateVisible = false;
  }

  repaint(): void {
    this.impersonatePopup.instance.repaint();
  }

  onImpersonateClick(): void {
    if (this.isValidAccountNumberOrUserID() == false) {
      return;
    }
    this.loadingVisible = true;

    RxjsUtils.safeSubscribe(
      this.userService.impersonate(this.impersonateParameter),
      (impersonateResult: ImpersonateResultDto) => {
        this.userService.setImpersonateHistory(this.impersonateParameter);
        this.loadingVisible = false;
        this.hide();
        // Navigate to home page after impersonation
        this.router.navigate(['/home']);
        this.enableApplyButton();
      },
      (error) => {
        const index = this.impersonateHistory.indexOf(
          this.impersonateParameter
        );
        this.impersonateHistory.splice(index, 1);
        this.loadingVisible = false;
        //Overriding server status and message in case of 401 Unauthorized
        if (error.status === 403) {
          this.errorService.updateSubjectErrorMessage(
            `You do not have access to one or more communities of the impersonating account!`
          );
        } else if (error.status === 400) {
          this.errorService.updateSubjectErrorMessage(
            `Invalid account number. Please verify!`
          );
        } else {
          this.errorService.displayError(error);
        }
      }
    );
  }

  onCancelClick(): void {
    this.hide();
  }

  onImpersonateInputChange(event) {
    if (event.value) {
      const impersonateParams = new ImpersonateParameterDto();
      impersonateParams.userName = event.value;
      this.impersonateParameter = impersonateParams;
    }
    this.enableApplyButton();
  }

  addNewImpersonateUser(event) {
    const impersonateParams = new ImpersonateParameterDto();
    impersonateParams.userName = event.text;
    if (!!event.text && !!event.text.length) {
      this.impersonateHistory.push(impersonateParams);
    }
    this.impersonateParameter = impersonateParams;

    this.enableApplyButton();
  }

  private isValidAccountNumberOrUserID(): boolean {
    if (!this.impersonateParameter) {
      this.validatorImpersonate.instance.validate().status = 'invalid';
      this.validatorImpersonate.instance.validate().isValid = false;
      return false;
    } else {
      return true;
    }
  }

  private enableApplyButton(): void {
    if (this.impersonateParameter) {
      if (this.impersonateParameter.userName) {
        this.isImpersonateDisabled = false;
      } else {
        this.isImpersonateDisabled = true;
      }
    } else {
      this.isImpersonateDisabled = true;
    }
  }
}
